<template>
  <tab-item-template>
    <data-property-profile-list
      :data-property-profiles="dataPropertyProfiles">
    </data-property-profile-list>
  </tab-item-template>
</template>

<script>
import TabItemTemplate from "@/components/templates/TabItemTemplate.vue";
import DataPropertyProfileList from "@/components/organisms/DataPropertyProfileList.vue";
import DataPropertyProfileSource from "@/components/organisms/DataPropertyProfileSource";
import {safeMeta} from "@/router/Meta";

export default {
  name: "DataPropertyProfileTab",
  components: {DataPropertyProfileList, TabItemTemplate},
  mixins: [DataPropertyProfileSource],
  props: {
    dataProfileId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dataPropertyProfiles: []
    }
  },
  computed: {
    isOwnedDataProfile() {
      return safeMeta(this.$route).isOwnedDataProfile ?? false;
    },
  },
  watch: {
    dataProfileId: {
      immediate: true,
      async handler() {
        this.dataPropertyProfiles = (this.isOwnedDataProfile ?
                await this.loadDataPropertyProfiles(this.dataProfileId) :
                await this.loadAssetsDataPropertyProfiles(this.dataProfileId))
            .map(dpp => {
              const dpi = dpp.dataPropertyImplementation;
              const commonDpd = dpp.commonDataPropertyDefinition;
              const localDpd = dpp.localDataPropertyDefinition;
              const viewDpd = (() => {
                if(dpp.commonDataPropertyDefinitionId) {
                  return commonDpd;
                } else if(dpp.localDataPropertyDefinitionId) {
                  return localDpd;
                } else {
                  return null;
                }
              })();
              return {
                ...dpp,
                index: dpi.index,
                defaultValue: dpi.defaultValue,
                name: viewDpd?.name,
                description: viewDpd?.description,
                dataType: localDpd?.dataType ?? 'string',
                isPrimaryKey: localDpd?.isPrimaryKey ?? false,
                isRequired: localDpd?.isRequired ?? false,
              };
            });
      }
    }
  }
}
</script>

<style scoped>

</style>
